var SENTRY_RELEASE;SENTRY_RELEASE={name: "Editor PhotoSì", version: "1.0.0"};